// 收款人类型
export enum RecipientType {
  UID = 'xid',
  Email = 'email',
  Phone = 'phone'
}

// 最近收款人
export interface RecentRecipient {
  id: string
  type: RecipientType
  value: string // UID/邮箱/手机号
  name?: string // 收款人昵称
  avatar?: string
  lastTransferTime: string
}

// 转账表单数据
export interface TransferFormData {
  coinType: string // 币种类型
  amount: string // 转账金额
  recipientType: RecipientType // 收款人类型
  recipientValue: string // 收款人信息
}
